import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface Chip {
  chave: string;
  rotulo: string;
  valor: string;
  aoRemover: () => void;
  className?: string | undefined;
}

/**
 * Filtros são chips já aplicados (regra 3): nada de formulário de parâmetros
 * antes do resultado. Cada chip mostra o filtro e sai com um clique.
 */
export function ChipsFiltro({
  chips,
  aoLimparTudo,
  className,
}: {
  chips: readonly Chip[];
  aoLimparTudo?: (() => void) | undefined;
  className?: string | undefined;
}): JSX.Element | null {
  if (chips.length === 0) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {chips.map((chip) => (
        <span
          key={chip.chave}
          className={cn(
            'group inline-flex items-center gap-1.5 rounded-full border border-primaria/25 bg-primaria-suave py-1 pl-3 pr-1 text-[12px] shadow-xs',
            chip.className,
          )}
        >
          <span className="text-[10px] font-bold uppercase tracking-wide text-primaria/70">
            {chip.rotulo}
          </span>
          <span className="max-w-[180px] truncate font-semibold text-primaria">{chip.valor}</span>
          <button
            type="button"
            onClick={chip.aoRemover}
            aria-label={`Remover filtro ${chip.rotulo} ${chip.valor}`}
            className="flex h-5 w-5 items-center justify-center rounded-full text-primaria/60 transition-colors hover:bg-primaria hover:text-white"
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      {chips.length > 1 && aoLimparTudo ? (
        <button
          type="button"
          onClick={aoLimparTudo}
          className="rounded-full px-2.5 py-1 text-[12px] font-medium text-textoFraco transition-colors hover:bg-superficie2 hover:text-texto"
        >
          limpar tudo
        </button>
      ) : null}
    </div>
  );
}
